export async function clearApiCacheAndReloadSW() {
	if (typeof window === 'undefined') return;

	try {
		if ('serviceWorker' in navigator) {
			const registrations = await navigator.serviceWorker.getRegistrations();

			await Promise.all(
				registrations.map(async (reg) => {
					try {
						reg.active?.postMessage({ type: 'CLEAR_API_CACHE' });
						await reg.update().catch((e) => console.error('CLEAR_API_CACHE: ', e));
						if (reg.waiting) {
							reg.waiting.postMessage({ type: 'SKIP_WAITING' });
						}
					} catch (error) {
						console.warn('[SW] Cleanup message failed', error);
					}
				}),
			);
		}

		if ('caches' in window) {
			await caches.delete('api-cache').catch((e) => console.error('api-cache: ', e));
		}
	} catch (error) {
		console.warn('[SW] Cleanup failed', error);
	}
}

export async function unregisterServiceWorkersAndClearCaches() {
	if (typeof window === 'undefined') return;
	try {
		if ('serviceWorker' in navigator) {
			const registrations = await navigator.serviceWorker.getRegistrations();
			await Promise.all(
				registrations.map(async (reg) => {
					try {
						reg.active?.postMessage({ type: 'CLEAR_API_CACHE' });
					} catch (error) {
						console.warn('[SW] postMessage CLEAR_API_CACHE failed', error);
					}
					try {
						await reg.unregister();
					} catch (error) {
						console.warn('[SW] unregister failed', error);
					}
				}),
			);
		}

		if ('caches' in window && caches.keys) {
			const keys = await caches.keys();
			await Promise.all(
				keys.map((key) =>
					caches.delete(key).catch((error) => console.warn('[SW] cache delete failed', key, error)),
				),
			);
		}
	} catch (error) {
		console.warn('[SW] Hard cleanup failed', error);
	}
}

export default clearApiCacheAndReloadSW;
